import { Component, DestroyRef } from '@angular/core';
import { filter, take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';
import { AnalyticsService } from '@monorepo/analytics';
import { ChatbotLifecycleService } from '@monorepo/chatbot';
import { FirebaseAnalyticsService, PushNotificationService, UnifiedLoginService } from '@monorepo/services';
import { environment } from '../environments/environment';
import { TP8FirebaseAnalyticsEvent } from '@monorepo/types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'monorepo-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private translate: TranslateService,
    private platform: Platform,
    private pushNotificationService: PushNotificationService,
    private firebaseAnalyticsService: FirebaseAnalyticsService<TP8FirebaseAnalyticsEvent>,
    private unifiedLoginService: UnifiedLoginService,
    private analyticsService: AnalyticsService,
    private chatbotLifecycleService: ChatbotLifecycleService,
    private destroyRef: DestroyRef,
  ) {
    this.translate.setDefaultLang('en');

    this.unifiedLoginService.registerSessionCleanupHandler(() => this.analyticsService.cleanup());

    this.unifiedLoginService.loginStatus$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((loginStatus) => loginStatus === 'SESSION_EXPIRED'),
        take(1),
      )
      .subscribe(() => this.chatbotLifecycleService.terminate());

    this.platform.ready().then(async () => {
      await SplashScreen.hide();
      this.pushNotificationService.registerDevice().then(() => {
        console.log('[Push-Test] AppComponent pushNotificationService register success');
        return true;
      });

      if (environment.production)
        await this.firebaseAnalyticsService.init(
          true,
          {
            apiKey: 'AIzaSyDvKZ3SATvD1gXnYJjLIRx9yOXG7a6hrjk',
            authDomain: 'plani8.firebaseapp.com',
            projectId: 'plani8',
            storageBucket: 'plani8.appspot.com',
            messagingSenderId: '1015767686377',
            appId: '1:1015767686377:web:6f1e7f4487a8587c3aa478',
            measurementId: 'G-7JFJW1HWPJ',
          },
          this.unifiedLoginService.getUsername(),
        );
      else console.log('(firebase-analytics) Firebase Analytics is disabled in dev mode.');
    });
  }
}
